


export function initGTM () {
  const dl = 'dataLayer';
  window[dl] = window[dl] || [];
  window[dl].push({
    'gtm.start': new Date().getTime(), 
    event: 'gtm.js'
  });
  return lazyLoadScript(`https://www.googletagmanager.com/gtm.js?id=GTM-TJCCMTG`);
}


/**
 * @typedef {Object} LazyloadOptions
 * @property {string} id
 * @property {boolean} async - If true adds an async attribute
 * @property {boolean} defer - If true adds a defer attribute
 * @property {string} integrity - If set adds an integrity attribute
 * @property {string} type - If set adds a type attribute
 * @property {string} text - If set adds an text attribute
 * @property {string} charset - If set adds an charset attribute
 * @property {string} crossorigin - If set adds an crossorigin attribute
 * @property {boolean} force - If true forces an asset to be loaded even if another with the same id or href are found
 */

/**
 * @param {string} src
 * @param {string | Partial<LazyloadOptions>} [opts={}]
 * @returns {Promise<HTMLScriptElement | HTMLElement | Element>}
 */
function lazyLoadScript(src, opts = {}) {

  if(!src) {
    throw new Error('src parameter must be specified');
  }
  
  return new Promise(function(resolve, reject) {

    const defaults = { force: false };
    const { id, async, integrity, type, text, defer, charset, crossorigin, force } = Object.assign(
      {}, defaults, 
      (typeof opts === 'string') 
        ? { id: opts } 
        : opts
    );

    const script = document.createElement('script');
    script.src = src;

    if (id) {
      script.setAttribute('id',id);
      if(document.getElementById(id)) {
        resolve(document.getElementById(id));
        return;
      }
    } else {
      const sc = document.querySelector(`script[src="${src}"]`);
      if (!force && sc) {
        resolve(sc);
        return;
      }
    }

    if (async) script.setAttribute('async', 'true');
    if (defer) script.setAttribute('defer', 'true');
    if (integrity) script.setAttribute('integrity', integrity);
    if (type) script.setAttribute('type', type);
    if (text) script.setAttribute('text', text);
    if (charset) script.setAttribute('charset', charset);
    if (crossorigin) script.setAttribute('crossorigin', crossorigin);

    script.onload = () => resolve(script);
    script.onerror = (event) => reject(event);
    document.body.appendChild(script);
  });

}